module.exports = __webpack_public_path__ + "static/media/miasto_in_progress.c2aaecc4.svg";